<app-page>
    <app-order [orderInput]="order" [fromPage]="fromPage" *ngIf="order"></app-order>
    <app-order [orderId]="orderId" [fromPage]="fromPage" *ngIf="orderId"></app-order>
</app-page>
